import PluginUtils, { getPluginData, PluginType } from '../PluginUtils';
import { OrderPageIntent } from '../OrderPageIntent';

export enum OrderPageErrors {
  DATE_AND_TIME_NOT_SELECTED = 'dateAndTimeNotSelected',
  SAVE_ORDER_EXCEPTION = 'saveOrderException',
  PHONE_NUMBER_SAVE_ORDER_EXCEPTION = 'phoneNumberSaveOrderException',
  AT_LEAST_ONE_PERSON = 'atLeastOnePerson',
}

// this is used in case voucher is not valid for weekend and being redeemed
export const calculateShouldHideWeekends = (orderPageState: any) => {
  const pluginData = getPluginData(orderPageState.orderPage.plugins, PluginType.WEEKEND_AND_ISRAELI_HOLIDAYS);
  if (!pluginData) {
    return false;
  }
  const customDetails = orderPageState.voucher?.custom_details || orderPageState.details.custom_details;
  return (
    !PluginUtils.customDetailsHasPlugin(customDetails, PluginType.WEEKEND_AND_ISRAELI_HOLIDAYS) &&
    orderPageState.orderPageIntent === OrderPageIntent.REDEEM_GIFT_CARD
  );
};
